window.addEventListener("turbo:load", init_sort);
window.addEventListener("turbo:frame-load", init_sort);

/* Main function to call all initializers */
export function init_sort(event) {
  const html= (event.currentTarget) ? event.currentTarget.document : event
  apply_sort(html);
}

function apply_sort(html= document) {
  /* Sortable list containers: */
  $('[data-sort-url]', html).sortable({
    axis: $('[data-sort-url]').data('sort-axis'),     // Declare data-sort-axis with x (horizontal), y (vertical) or empty/false (grid)
    cursor: 'crosshair',
    opacity: 0.4,
    update: function(event, ui){
      $.ajax({
        type: 'post',
        data: $(this).sortable('serialize'),
        dataType: 'script',
        url: $(this).data('sort-url')})
    }
  });
}